module.exports = __webpack_public_path__ + "static/media/dm.5c6d3f5b.svg";